import {
  require_camelcase
} from "./chunk-DZIKNQT5.js";
import "./chunk-TFWDKVI3.js";
export default require_camelcase();
//# sourceMappingURL=camelcase.js.map
